import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { map, split, join, flow } from 'lodash';

export type UrlEscapeFilter = (input: string) => string;

interface IUrlEscape {
  transform: UrlEscapeFilter;
}

/**
 * Filter that takes any string and returns url safe version.
 * @param {string} input string to be transformed
 * @return {string} url safe string
 */
@Pipe({ name: 'urlEscape' })
export class UrlEscapePipe implements PipeTransform, IUrlEscape {
  constructor() {
    'ngInject';
  }

  public transform(input: string): string {
    if (angular.isString(input)) {
      return flow(
        (x) => split(x, '/'),
        (x) => map(x, encodeURIComponent),
        (x) => join(x, '/'),
      )(input);
    } else {
      return input;
    }
  }
}
